<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-header">
        <div class="header-left">
          <el-button
            type="primary"
            size="small"
            @click="
              (dialogVisible = true),
                (serviceForm.serviceName = ''),
                (serviceForm.printerDevicesId = [])
            "
            >发布服务</el-button
          >
          <el-button
            type="primary"
            size="small"
            v-if="isShowLinkToLiveBtn"
            @click="linkToLivePage"
            >直播</el-button
          >
        </div>
      </div>
      <div class="tab-content">
        <div class="list">
          <el-table :data="serviceList" style="width: 100%">
            <el-table-column label="服务内容" prop="serviceName" />
            <el-table-column label="打印机名称" prop="printDeviceNames" />
            <el-table-column label="操作" header-align="right">
              <template slot-scope="scope">
                <div class="float-right">
                  <el-button size="small" type="primary" @click="edit(scope.row)" plain
                    >编辑</el-button
                  >
                  <el-button
                    size="small"
                    type="danger"
                    @click="del(scope.row.customServiceId)"
                    plain
                    >删除</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <div slot="title" class="dialog-title">
        {{ serviceForm.customServiceId ? "编辑店铺服务" : "发布店铺服务" }}
      </div>
      <span>
        <el-form ref="serviceForm" :model="serviceForm">
          <el-form-item label="服务内容">
            <el-input
              type="textarea"
              v-model="serviceForm.serviceName"
              style="width: 350px"
              placeholder="输入服务内容..."
            ></el-input>
          </el-form-item>
          <el-form-item label="打印设备">
            <el-select
              style="width: 350px"
              v-model="serviceForm.printerDevicesId"
              multiple
              placeholder="请选择打印设备"
              filterable
              allow-create
              default-first-option
            >
              <el-option
                v-for="item in printList"
                :key="item.printerDevicesId"
                :label="item.deviceName"
                :value="item.printerDevicesId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="(dialogVisible = false), (serviceForm.customServiceId = '')"
          >取 消</el-button
        >
        <el-button type="primary" @click="save">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  CustomServiceList,
  delCustomServiceList,
  getPrinterDevices,
  saveOrUpdateService,
} from "../api/index";
export default {
  data() {
    return {
      serviceList: [],
      queryInfo: {
        pageNo: 1,
        row: 10,
      },
      dialogVisible: false,
      serviceForm: {
        serviceName: "",
        printerDevicesId: [],
        customServiceId: "",
      },
      printList: [],
    };
  },
  computed: {
    isShowLinkToLiveBtn() {
      return (
        !!~location.href.indexOf("xcx.houfubaokeji.com") ||
        !!~location.href.indexOf("192.168")
      );
    },
  },
  created() {
    this.getPrinterDevices();
  },
  methods: {
    linkToLivePage() {
      window.open("https://live.douyin.com");
    },
    async getCustomServiceList() {
      await CustomServiceList({
        pageNo: this.queryInfo.pageNo,
        row: this.queryInfo.row,
      }).then((res) => {
        if (res.code == 1) {
          this.serviceList = res.data;
        } else if (res.code == -1) {
          this.serviceList = [];
        } else if (res.code == 2) {
          this.$router.push("/");
          this.$message.error(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getPrinterDevices() {
      getPrinterDevices({}).then((res) => {
        if (res.code == 1) {
          this.printList = res.data;
          this.getCustomServiceList();
        } else if (res.code == -1) {
          this.printList = [];
        } else if (res.code == 2) {
          this.$router.push("/");
          this.$message.error(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.serviceForm.customServiceId = "";
      this.serviceForm = {};
    },
    edit(row) {
      this.serviceForm.printerDevicesId = [];
      let printDevices = row.printDevices.split(",");
      printDevices.forEach((val, index) => {
        this.serviceForm.printerDevicesId.push(Number(val));
      });
      this.dialogVisible = true;
      this.serviceForm.customServiceId = row.customServiceId;
      this.serviceForm.serviceName = row.serviceName;
    },
    del(id) {
      console.log(id);
      this.$confirm("您确定要删除该条服务吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delCustomServiceList({
            customServiceId: id,
          }).then((res) => {
            if (res.code == 1) {
              this.getCustomServiceList();
              this.$message.success("删除成功");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    save() {
      let printDevices = this.serviceForm.printerDevicesId.join(",");
      saveOrUpdateService({
        serviceName: this.serviceForm.serviceName,
        printDevices: printDevices,
        customServiceId: this.serviceForm.customServiceId
          ? this.serviceForm.customServiceId
          : null,
      }).then((res) => {
        if (res.code == 1) {
          this.getCustomServiceList();
          this.dialogVisible = false;
          this.$message.success(
            `${this.serviceForm.customServiceId ? "编辑成功" : "发布成功"}`
          );
          this.serviceForm.customServiceId = "";
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .tab-content {
    display: block;
    padding: 20px;
  }
  .el-dialog {
    .el-select {
      width: 100%;
    }
    .dialog-title {
      font-weight: bold;
    }
    .ruleForm-bottom {
      margin-top: 20px;
    }
  }
}
</style>
